export default "__VITE_ASSET__CnjlE26s__"